import { useLocation } from 'react-router-dom';
import { ROUTER_PATH } from 'router/const/routerPath.const';

/**
 * True when the current page is the RAC (Regional Acceptance) flow.
 *
 * RAC has no Lender DB row, so it can't be matched by lender id; gamification
 * scoping for RAC keys off this route-based context instead.
 */
export const useIsRacContext = (): boolean => {
  const { pathname } = useLocation();
  const racPath = ROUTER_PATH.RAC_AFFORDABILITY_ENGINE;

  return pathname === racPath || pathname.startsWith(`${racPath}/`);
};
